<template lang="pug">
div
  index-page(
    @set-loading="setLoading",
    :parentData="{ grid: grid, path: path, grid_key: grid_key, report_class: report_class, report_namespace: report_namespace }"
  )

  ui-prompts(v-if="!child_route_component", :parentData="{ areas_key: grid }")
</template>

<script>
import indexPage from "../../../shared/indexPage";
import uiPrompts from "../../../shared/ui_prompts/index.vue";
import { useEmitter } from "@/services/useEmitter";

export default {
  components: {
    indexPage,
    uiPrompts,
  },
  data: function () {
    return {
      grid: "ppr_equipments",
      report_class: "equipment",
      report_namespace: "ppr",
      path: this.$store.state.paths["ppr_equipment"],
      grid_key: "data",
      child_route_component: false,
      emitter: useEmitter(),
    };
  },

  beforeMount() {
    this.$emit("expand-class", { val: false, class: "" });
  },

  beforeDestroy() {
    this.emitter.off("set-child-route-component");
  },

  created() {
    this.$root.$on("set-child-route-component", val => {
      this.child_route_component = val;
    });

    this.emitter.on("set-child-route-component", val => {
      this.child_route_component = val;
    });
  },

  methods: {
    setLoading(val) {
      this.$emit("set-loading", val);
    },
  },
};
</script>

<style lang="scss"></style>
